import * as moment from "moment";

declare module "moment" {
    interface Moment {
        addDays(days: number): moment.Moment,
        addBusinessDays(days: number): moment.Moment
    }
}

(moment as any).fn.addDays = function (days: number): moment.Moment {
    this.add(days, 'day');
    return this;
};

(moment as any).fn.addBusinessDays = function (days: number): moment.Moment {
    var i = 0;

    while (i < days) {
        this.add(1, 'day');
        if (this.day() > 0 && this.day() < 6) {
            i++;
        }
    }

    return this;
};
